import { useEffect, useState } from 'react';
import { defaultSelectedValue, } from './base-select';
const getOptionResults = (searchTerm, optionsGroups, canSearchSubText = false) => optionsGroups.reduce((results, group) => {
    const matchedOptions = group.options.filter((option) => {
        var _a;
        let searchText = (_a = option.label) !== null && _a !== void 0 ? _a : '';
        if (canSearchSubText) {
            searchText += option.subText;
        }
        return searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase().includes(searchTerm.toLowerCase());
    });
    if (!matchedOptions.length && !group.emptyState) {
        return results;
    }
    const { title = '', titleButton = undefined, emptyState = '' } = group;
    return results.concat({
        title,
        titleButton,
        emptyState,
        options: matchedOptions,
    });
}, []);
export const useSelect = (show, optionsGroups, onSearchInput, defaultSelected = defaultSelectedValue, canSearchSubText) => {
    const [visible, setVisible] = useState(show);
    const [selectedValue, setSelectedValue] = useState(defaultSelected);
    const [searchTerm, setSearchTerm] = useState('');
    const [optionsResults, setOptionsResults] = useState(optionsGroups);
    useEffect(() => {
        /**
         * If onSearchInput is provided don't filter value
         */
        if (onSearchInput) {
            onSearchInput(searchTerm);
            setOptionsResults(optionsGroups);
            return;
        }
        /** Filter Options Logic */
        setOptionsResults(getOptionResults(searchTerm, optionsGroups, canSearchSubText));
    }, [onSearchInput, optionsGroups, searchTerm, canSearchSubText]);
    return {
        visible,
        setVisible,
        selectedValue,
        setSelectedValue,
        searchTerm,
        setSearchTerm,
        optionsResults,
        setOptionsResults,
    };
};
//# sourceMappingURL=select-util.js.map